import axios from 'axios';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: '/api/dataview'
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

// ----------------------------
// AUM SERVICES
// ----------------------------

async function getFullBook(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/aum/full-book', payload, requestOptions);

  return response.data;
}

async function getFullBookTotal(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/aum/full-book-multi-date', payload, requestOptions);

  return response.data;
}

async function getAdvisorsAcrossProviders(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post(
    '/aum/advisors-across-providers',
    payload,
    requestOptions
  );

  return response.data;
}

async function getProviderAum(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/aum/all-providers', payload, requestOptions);

  return response.data;
}

async function getAdvisorBookSummary(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/aum/advisor', payload, requestOptions);

  return response.data;
}

async function getProviderBookSummary(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/aum/provider', payload, requestOptions);

  return response.data;
}

async function getAumStats(payload) {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/aum/growth-stats', payload, requestOptions);

  return response.data;
}

export const aumService = {
  getAdvisorsAcrossProviders,
  getProviderAum,
  getAdvisorBookSummary,
  getProviderBookSummary,
  getAumStats,
  getFullBookTotal,
  getFullBook
};
